/** How long the parties skeleton may stay up before a document navigation. */
export const NATIVE_PARTIES_REDIRECT_FALLBACK_MS = 8000;

/**
 * The launch screen starts a client navigation to /parties. If that commit
 * never finishes, the skeleton stays up. A changed URL needs a reload; a
 * launch page that never left home needs a document replace.
 */
export function recoverStuckNativePartiesRedirect(
  pathname: string,
): "reload" | "replace" {
  if (pathname === "/parties" || pathname.startsWith("/parties/")) {
    return "reload";
  }
  return "replace";
}
